import { useEffect, useState } from "react";
import { Spinner } from 'react-bootstrap';
import { FaTimesCircle, FaUserMinus, FaUserPlus } from "react-icons/fa";
import { FiMessageCircle } from "react-icons/fi";
import { fetchSelectedUserFriend, fetchUserScoreBoard } from "./Api";
import MessageModal from "./MessageModal";


import axiosInstance from "@/lib/axios";

function ProfileModal({ userId, onClose, modalRef }) {
  const [showMessageModal, setShowMessageModal] = useState(false);
  const [user, setUser] = useState({
    full_name: "",
    email: "",
    profile_image: null,
    status: "none",
    request_type: null,
    friendship_status: null,
    birthdate: null,
    gender: null,
    weight: null,
    height: null,
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const [getScoreBoard, setScoreBoard] = useState([]);


  useEffect(() => {
    if (!userId) return;

    let isMounted = true; // avoid state updates if component unmounts

    const fetchData = async () => {
      try {
        setLoading(true);

        // Fetch user data and scoreboard in parallel
        const [userData, scoreData] = await Promise.all([
          fetchSelectedUserFriend(userId),
          fetchUserScoreBoard(userId),
        ]);

        if (isMounted) {
          setUser(userData);
          setScoreBoard(scoreData.scoreboard ?? []);
        }
      } catch (err) {
        console.error(err);
        if (isMounted) setError("Failed to fetch user or scoreboard");
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    fetchData();

    return () => {
      isMounted = false; // cancel updates if component unmounts
    };
  }, [userId]);




  const handleFriendAction = async (action) => {
    try {
      switch (action) {
        case "send":
          await axiosInstance.post("/users/friends", { receiver_id: user.id });
          setUser((prev) => ({
            ...prev,
            friendship_status: "pending",
            status: "pending",
            request_type: "outgoing",
          }));
          break;
        case "cancel":
        case "unfriend":
          await axiosInstance.delete(`/users/friends/${user.id}`);
          setUser((prev) => ({
            ...prev,
            friendship_status: "none",
            status: "none",
            request_type: null,
          }));
          break;
        default:
          return;
      }
    } catch (err) {
      console.error("Action failed:", err);
      alert("Failed to perform action.");
    }
  };

  const renderFriendAction = () => {
    const status = user.friendship_status || "none";
    const mapping = {
      none: { label: "Send Friend Request", icon: <FaUserPlus />, action: "send" },
      pending: { label: "Cancel Request", icon: <FaTimesCircle />, action: "cancel" },
      rejected: { label: "Reject", icon: <FaTimesCircle />, action: "cancel" },
      accepted: { label: "Unfriend", icon: <FaUserMinus />, action: "unfriend" },



    };
    const { label, icon, action } = mapping[status] || mapping.none;

    return (

      <button
        onClick={() => handleFriendAction(action)}
        title={label} // tooltip on hover
        style={{
          padding: "6px 14px",
          borderRadius: "6px",
        //  border: "1px solid #ccc",
        //  background: "#ff9b45",
          cursor: "pointer",
          fontSize: "14px",
          fontWeight: "500",
          display: "flex",
          alignItems: "center",
          gap: "6px",
          transition: "all 0.2s ease", // smooth hover effect
        }}
        onMouseEnter={e => (e.currentTarget.style.backgroundColor = "#ffb347")} // lighter color on hover
        onMouseLeave={e => (e.currentTarget.style.backgroundColor = "#ff9b45")} // restore color
      >
        {icon && icon}
      </button>

    );
  };


  return (
    <>

      <div
        className="nested-modal"
        ref={modalRef}
        onMouseDown={(e) => e.stopPropagation()}
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          height: "100vh",
          width: "100vw",
        //  backgroundColor: "rgba(0,0,0,0.6)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 1010,
          padding: "10px",
          boxSizing: "border-box",
        }}
      >
        <div
          style={{
            background: "rgb(70, 25, 5)",
            padding: "20px",
            borderRadius: "10px",
            width: "100%",
            maxWidth: "800px",
            minHeight: "400px",
            display: "flex",
            flexWrap: "wrap",
            gap: "20px",
            position: "relative",
          //  color: "white", // ← makes all text white
            fontFamily: "Inter, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif"

          }}
        >
          <button
            onClick={onClose}
            style={{
              position: "absolute",
              top: "10px",
              right: "10px",
              background: "transparent",
              border: "none",
              fontSize: "20px",
              cursor: "pointer",
            }}
          >
            ❌
          </button>

          {/* LEFT SECTION */}
          <div
            style={{
              flex: "0 0 150px",
              textAlign: "center",
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            {user.profile_image ? (
              <img
                src={`${user.profile_image}?t=${Date.now()}`} // cache-busting
                alt={user.full_name || "Avatar"}
                style={{
                  width: "100px",
                  height: "100px",
                  borderRadius: "50%",
                  objectFit: "cover",
                  marginBottom: "8px",
                }}
              />
            ) : (
              <div
                className="bg-secondary rounded-circle d-flex align-items-center justify-content-center"
                style={{
                  width: "100px",
                  height: "100px",
                  fontSize: "36px",
                 // color: "white",
                  fontWeight: "bold",
                  marginBottom: "8px",
                }}
              >
                {user.full_name?.charAt(0).toUpperCase() || "U"}
              </div>



            )}



            <div
              style={{
                display: "flex",
                gap: "6px",
                flexWrap: "wrap",
                justifyContent: "center",
                marginBottom: "6px",
              }}
            >
              <button
                onClick={() => setShowMessageModal(true)}
                disabled={loading}
                style={{
                  padding: "4px 8px",
                  borderRadius: "6px",
               //   border: "1px solid #ccc",
                 // background: "#ff9b45",
                  cursor: "pointer",
                  fontSize: "16px",
                }}
              >
                <FiMessageCircle />
              </button>
              {!loading && renderFriendAction()}
            </div>

            <div
              style={{
                display: "flex",
                gap: "2px",
                justifyContent: "center",
              }}
            >
              {Array.from({ length: 5 }, (_, i) => {
                const rating = user.avg_rating ?? 0;
                const isFull = i + 1 <= Math.floor(rating);
                return (
                  <span
                    key={i}
                    style={{
                      fontSize: "28px",
                    //  color: isFull ? "#FFB400" : "#DDD",
                    }}
                  >
                    {isFull ? "★" : "☆"}
                  </span>
                );
              })}
            </div>
          </div>

          {/* VERTICAL LINE SEPARATOR */}
          <div
            style={{
              width: "1px",
            //  backgroundColor: "#ccc",
              margin: "0 20px",
            }}
            className="vertical-separator"
          />

          {/* RIGHT SECTION */}
          <div
            style={{
              flex: "2 1 300px",
              minWidth: "300px",
              textAlign: "left",
              width: "100%",
            }}
          >
            <h3>{user.full_name}</h3>

            <ul style={{ padding: 0, margin: 0, listStyle: "none" }}>
              {loading ? (
                <li style={{ padding: "10px" }}>
                  <Spinner animation="border" variant="warning" size="sm" />
                </li>
              ) : (
                <li>
                  <ul
                    style={{
                      display: "flex",
                      gap: "8px",
                      flexWrap: "wrap",
                      padding: 0,
                      margin: 0,
                      listStyle: "none",
                    }}
                  >
                    <li>{user.age || "N/A"}</li>
                    <li>|</li>
                    <li>{user.gender || "N/A"}</li>
                    <li>|</li>
                    <li>{user.height || "N/A"} ft.</li>
                    <li>|</li>
                    <li>{user.weight || "N/A"} kg.</li>
                    <li>|</li>
                    <li>{user.location || "N/A"}</li>
                  </ul>
                </li>
              )}
            </ul>

            {getScoreBoard && (
              <>
                <hr style={{ margin: "12px 0" }} />
                <h4>Scoreboard</h4>
                {loading ? (
                  <div style={{ padding: "6px 0", 
                   // color: "#666" 
                  
                  }}>Loading...</div>
                ) : getScoreBoard.length > 0 ? (


                  <div
                    style={{
                      border: "1px solid #740A03",
                      borderRadius: "6px",
                    //background: "rgb(251, 184, 85)",
                      width: "100%",
                      overflowY: "auto",
                      maxHeight: "200px",
                    }}
                  >
                      <table
                        style={{
                          width: "100%",
                          borderCollapse: "separate",
                          borderSpacing: "0",
                          textAlign: "center",
                          position: "relative",
                          transform: "translateZ(0)",
                        }}
                      >
                        <thead style={{ 
                          backgroundColor: "#740A03",
                          color: "white",
                          position: "sticky",
                          top: 0,
                          zIndex: 9999,
                          transform: "translateZ(0)",
                          isolation: "isolate",
                          backfaceVisibility: "hidden"}}>
                          <tr>
                            <th
                              style={{
                                padding: "6px",
                              }}
                            >
                              Sports
                            </th>

                            <th
                              style={{
                                padding: "6px",
                              }}
                            >
                              Score
                            </th>

                            <th
                              style={{
                                padding: "6px",
                              }}
                            >
                              Tier
                            </th>
                          </tr>
                        </thead>

                        <tbody style={{
                          background: "transparent",
                          position: "relative",
                          zIndex: 1,
                        }}>
                          {getScoreBoard.map((item) => (
                            <tr key={item.sports_id}>
                              <td
                                style={{
                                  padding: "6px",
                                  textAlign: "center",
                                }}
                              >
                                {item.sport_name}
                              </td>

                              <td
                                style={{
                                  padding: "6px",
                                  fontWeight: "bold",
                                  textAlign: "center",
                                }}
                              >
                                {item.score}
                              </td>

                              <td
                                style={{
                                  padding: "6px",
                                  textAlign: "center",
                                }}
                              >
                                {item.tier_name}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>


                ) : (
                  <div style={{ padding: "6px 0", // color: "#666"


                   }}>No data</div>
                )}
              </>
            )}
          </div>

          {/* RESPONSIVE STYLES */}
          <style>
            {`
        @media (max-width: 768px) {
          .nested-modal > div {
            flex-direction: column !important;
            height: auto !important;
            padding: 10px !important;
          }
          .vertical-separator {
            display: none !important;
          }
        }
      `}
          </style>
        </div>
      </div>


      {showMessageModal && (
        <MessageModal
          user={user}
          onClose={() => setShowMessageModal(false)}
          onSend={(msg) => console.log("Message sent:", msg)}
        />
      )}
    </>
  );
}

export default ProfileModal;
